import { capitalizeString } from './capitalize-string';
export function camelCaseToSpaces(str, options) {
    if (!str) {
        return '';
    }
    const spacedString = str.replace(/([a-z])([A-Z])/g, '$1 $2');
    if (options === null || options === void 0 ? void 0 : options.capitalize) {
        return capitalizeString(spacedString);
    }
    return spacedString;
}
//# sourceMappingURL=camel-case-to-space.js.map